import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import StickyObserver from "./StickyObserver";
import Consent from "./consent/consent";
import { navigation, header } from "./navigation/navigation";
import { contrastToggler, contrast } from "./bitv/contrast";
import { zoomController, zoom } from "./bitv/zoom";
import { titusController } from "./bitv/titus";
import { initSidebarScrollSpy } from "./scrollspySidebar";

// Plugins
Alpine.plugin(collapse);

// Stores
Alpine.store("contrast", contrast);
Alpine.store("zoom", zoom);

// Components
Alpine.data("cookieSettings", Consent.getCookieSettingsComponent());
Alpine.data("navigation", navigation);
Alpine.data("header", header);
Alpine.data("contrastToggler", contrastToggler);
Alpine.data("zoomController", zoomController);
Alpine.data("titusController", titusController);

// Global
window.Alpine = Alpine;

new StickyObserver("#header", "is-sticky-header");

// Inits
Consent.init();
Alpine.start();

// Sidebar scrollspy (if sidebar exists)
document.addEventListener("DOMContentLoaded", () => {
	initSidebarScrollSpy(".sidebar-nav");
});

// Sidebar scrollspy (if sidebar exists)
document.addEventListener("DOMContentLoaded", () => {
	initSidebarScrollSpy(".sidebar-nav");
});
